export const FALLBACK_ICON = 'gousto_g'
export const FALLBACK_COLOR = '#333D47'
